import React, { useState, useEffect } from 'react';
import PageWrapper from './../PageWrapper';

function Team() {
	return (
		<PageWrapper title="team">
			<div>
				<header class="header">
					<div class="container">
						<div class="top-dec w-left">
							<div class="breadcrumbs">
								<h1>Team</h1>
							</div>
						</div>
					</div>
				</header>
				<div class="mdc_team_introduce mb">
					<div class="container">
						<div class="row ">
							<div class="col-12 col-md-4 team_ceo">
							<div class="team_ceo_a"><img src={require("../../images/doctor_1.png")} /></div>
							</div>
							<div class="col-12 col-md-8" style={{paddingTop:20}}>
								<h2>Introduce Our Team</h2>
								<p>Fusce dapibus metus lectus, eu pretium magna suscipit gravida. Sed in accumsan justo.</p>
								<p>Maecenas nibh odio, tristique in dolor ornare, auctor maximus quam. Proin malesuada maximus fringilla. Vestibulum pulvinar convallis enim, quis auctor odio cursus in. Quisque eu libero ullamcorper nibh tempus viverra.</p>
								<span>- Founder / CEO</span>
							</div>
						</div>
					</div>
				</div>

				<div className="mdc_team mb">
					<div className="mdc-title">
						<h2>Our Professionals</h2>
					</div>
					<div className="container">
						<div className="row">
							<div className="col-12 col-sm-6 col-lg-3">
								<div className="team_inner">
								<div class="team_inner_a"><img src={require("../../images/doctor_1.png")} /></div>
									<h3>Dr Suspendisse cursus</h3>
									<span>Surgeon</span>
									<p> Vivamus ut euismod nulla, vel tincidunt enim. Sed lectus neque, </p>

								</div>
							</div>
							<div className="col-12 col-sm-6 col-lg-3">
								<div className="team_inner">
								<div class="team_inner_a"><img src={require("../../images/doctor_2.png")} /></div>
									<h3>Dr Nunc eleifend</h3>
									<span>Nurse</span>
									<p> Vivamus ut euismod nulla, vel tincidunt enim. Sed lectus neque, </p>

								</div>
							</div>
							<div className="col-12 col-sm-6 col-lg-3">
								<div className="team_inner">
								<div class="team_inner_a"><img src={require("../../images/doctor_3.png")} /></div>
									<h3>Dr Morbi convallis</h3>
									<span>Surgeon</span>
									<p> Vivamus ut euismod nulla, vel tincidunt enim. Sed lectus neque, </p>

								</div>
							</div>
							<div className="col-12 col-sm-6 col-lg-3">
								<div className="team_inner">
								<div class="team_inner_a"><img src={require("../../images/doctor_1.png")} /></div>
									<h3>Dr Duis nec</h3>
									<span>Assistance</span>
									<p> Vivamus ut euismod nulla, vel tincidunt enim. Sed lectus neque, </p>

								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="free_consultancy w-left">
					<div className="container">
						<div className="row">
							<div className="free_consult_inner">
								<div className="fc_left col-12 col-lg-3">
									<h3>Get Free Consultany</h3>
									<p><span>Call to</span><a href=":tel">+(9)677-788-8788</a></p>
								</div>
								<div className="fc_right col-12 col-lg-9">
									<form action="" method="">
										<input type="email" name="your email" placeholder="Your Email" />
										<input type="text" name="your name" placeholder="Your Name" />
										<input type="button" value="Get it Now" />
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</PageWrapper>
	);
}
export default Team;